module.exports = __webpack_public_path__ + "media/images/icons/check-pink-3e6436a0f1ab57dc8055921eca7dd708.svg";